export default __webpack_public_path__ + "static/media/681.a0b07fda.gif";